import { IImageInfo } from "@types";

const labelOf = (item: IImageInfo) =>
  String(Array.isArray(item.label) ? item.label[0] : (item.label ?? "")).toUpperCase();

// OK인데 점수가 높은 순 / NG인데 점수가 낮은 순 = threshold를 넘나들 위험이 큰 쪽부터
export const pickSnapshot = (validDataset: IImageInfo[], count = 8) => {
  const rows = (validDataset ?? []).filter((d) => d?.path && Number.isFinite(Number(d.score)));
  return {
    ok: rows
      .filter((d) => labelOf(d) === "OK")
      .sort((a, b) => Number(b.score) - Number(a.score))
      .slice(0, count),
    ng: rows
      .filter((d) => labelOf(d) === "NG")
      .sort((a, b) => Number(a.score) - Number(b.score))
      .slice(0, count),
  };
};

// 가운데 분포 그래프용: 0~1 구간을 bins개로 나눠 OK/NG 장수를 센다
export const scoreHistogram = (validDataset: IImageInfo[], bins = 50) => {
  const ok = new Array(bins).fill(0);
  const ng = new Array(bins).fill(0);
  (validDataset ?? []).forEach((d) => {
    const score = Number(d?.score);
    if (!Number.isFinite(score)) return;
    const i = Math.min(bins - 1, Math.max(0, Math.floor(score * bins)));
    (labelOf(d) === "OK" ? ok : ng)[i] += 1;
  });
  return { ok, ng, max: Math.max(1, ...ok, ...ng) };
};
